module.exports = __webpack_public_path__ + "img/progress_043.949c1ddc.png";